/* STEMZ terms checkbox: gates checkout until the customer ticks the terms box.
   Theme-only: it blocks the theme's checkout button, the express (Shop Pay etc.)
   buttons and /checkout links. It cannot stop someone typing /checkout directly. */
(function () {
  if (window.__stemzTerms) return; window.__stemzTerms = true;
  var SS = 'stemzTermsAgreed';
  var CHECKOUT = '[name="checkout"], #checkout, a[href$="/checkout"], a[href*="/checkout?"], a[href*="/checkouts/"]';
  var EXPRESS = '.additional-checkout-buttons, .cart__dynamic-checkout-buttons, .shopify-payment-button, shopify-accelerated-checkout-cart, shopify-accelerated-checkout';
  var saving = null;

  function boxes() { return Array.prototype.slice.call(document.querySelectorAll('[data-stemz-terms]')); }
  function ss(v) { try { if (v === undefined) return sessionStorage.getItem(SS); if (v === null) sessionStorage.removeItem(SS); else sessionStorage.setItem(SS, v); } catch (e) { return null; } }
  // Default TICKED: agreed unless the customer unticked it in this session.
  function agreed() { return ss() !== '0'; }
  function hasRecord() { return boxes().some(function (b) { return b.getAttribute('data-initial') === '1'; }); }
  function hasItems() { return boxes().some(function (b) { return parseInt(b.getAttribute('data-count') || '0', 10) > 0; }); }
  // Ticked (default or chosen) but this cart has no consent saved yet: write it once.
  // Skipped for empty carts so we never create cart attributes with nothing in the cart.
  function ensureRecord() { if (agreed() && !saving && !hasRecord() && hasItems()) save(true); }
  function meta() { var b = boxes()[0]; return b ? { key: b.dataset.key, vkey: b.dataset.versionKey, version: b.dataset.version } : null; }

  function save(on) {
    var m = meta(); if (!m) return Promise.resolve();
    var stamp = on ? new Date().toString() : '';
    if (on) { var prev = boxes().map(function (b) { var a = b.querySelector('[data-stemz-terms-at]'); return a && a.value; }).filter(Boolean)[0]; if (prev) stamp = prev; }
    boxes().forEach(function (b) {
      var a = b.querySelector('[data-stemz-terms-at]'), v = b.querySelector('[data-stemz-terms-version]');
      if (a) a.value = stamp; if (v) v.value = on ? m.version : '';
      b.setAttribute('data-initial', on ? '1' : '0');
    });
    var attrs = {}; attrs[m.key] = stamp; attrs[m.vkey] = on ? m.version : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    saving = fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .catch(function () {}).then(function () { saving = null; });
    return saving;
  }

  function sync() {
    if (!boxes().length) return;
    var ok = agreed();
    ensureRecord();
    boxes().forEach(function (b) {
      var i = b.querySelector('[data-stemz-terms-input]'); if (i && i.checked !== ok) i.checked = ok;
      if (!b.id) { b.id = 'stemz-terms-' + Math.random().toString(36).slice(2, 8); var er = b.querySelector('.stemz-terms__error'); if (er && i) { er.id = b.id + '-error'; i.setAttribute('aria-describedby', er.id); } }
      if (!ok) { var a = b.querySelector('[data-stemz-terms-at]'), v = b.querySelector('[data-stemz-terms-version]'); if (a) a.value = ''; if (v) v.value = ''; }
      if (ok) { b.classList.remove('is-error'); var e = b.querySelector('.stemz-terms__error'); if (e) e.hidden = true; }
    });
    document.querySelectorAll(CHECKOUT).forEach(function (el) {
      // no aria-disabled: the theme sets pointer-events:none on it, which would swallow the click and hide the error message
      if (ok) el.removeAttribute('data-stemz-locked'); else el.setAttribute('data-stemz-locked', '');
    });
    document.querySelectorAll(EXPRESS).forEach(function (el) {
      if (el.parentElement && el.parentElement.closest(EXPRESS)) return; // only the outermost wrapper
      if (ok) { el.removeAttribute('data-stemz-locked-wrap'); Array.prototype.forEach.call(el.children, function (c) { c.inert = false; }); }
      else { el.setAttribute('data-stemz-locked-wrap', ''); Array.prototype.forEach.call(el.children, function (c) { c.inert = true; }); }
    });
  }

  function nearestBox(el) {
    var scope = el.closest('form, .cart-summary, .mini-cart__footer, drawer-component');
    var b = scope && scope.querySelector('[data-stemz-terms]');
    if (b) return b;
    var vis = boxes().filter(function (x) { return x.offsetParent !== null; });
    return vis[0] || boxes()[0];
  }
  function block(e, el) {
    e.preventDefault(); e.stopImmediatePropagation();
    var b = nearestBox(el); if (!b) return;
    b.classList.add('is-error');
    var err = b.querySelector('.stemz-terms__error'); if (err) err.hidden = false;
    var i = b.querySelector('[data-stemz-terms-input]');
    if (i) { try { i.focus({ preventScroll: true }); } catch (x) {} b.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }

  document.addEventListener('change', function (e) {
    var i = e.target.closest && e.target.closest('[data-stemz-terms-input]'); if (!i) return;
    ss(i.checked ? '1' : '0'); save(i.checked); sync();
  }, true);

  ['click', 'pointerdown', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (agreed() || !boxes().length) return;
      if (type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target.closest && e.target.closest(CHECKOUT + ',' + EXPRESS + ',[data-stemz-locked-wrap]');
      if (!t) return;
      if (type === 'pointerdown' && !t.closest(EXPRESS + ',[data-stemz-locked-wrap]')) return; // express buttons act on pointerdown
      block(e, t);
    }, true);
  });

  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    var isCheckout = (s && s.name === 'checkout') || (e.target.querySelector && e.target.querySelector('input[type=hidden][name=checkout]'));
    if (!isCheckout || !boxes().length) return;
    if (!agreed()) { block(e, s || e.target); return; }
    if (saving) { e.preventDefault(); var f = e.target; saving.then(function () { if (f.requestSubmit && s) f.requestSubmit(s); else f.submit(); }); }
  }, true);

  function boot() {
    if (!boxes().length) return;
    sync(); // sync() also writes the consent record if the box is ticked and the cart has none
  }
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('pageshow', boot);
})();
